import React, { useState } from "react";
import "./CountryDropdown.css";

const CountryDropdown = (props) => {
    const [country, setCountry] = useState('')

    return (
        <div className="edit-profile-country-of-residence">
            <div className="first-name-h-eading">
                <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Country</div>
            </div>
            <select className="overlap-group-87 border-1px-mischka nunito-semi-bold-haiti-11-7px" onChange={(e) => {
                const selectedCountry = e.target.value;
                setCountry(selectedCountry);
                props.getCountryData(selectedCountry);
            }}>
                <option value=""></option>
                <option value="Canada">Canada</option>
                <option value="USA">United States</option>
            </select>
        </div>
    )
}

export default CountryDropdown;